import { get as fetch } from '../utils/fetch.util'

export const get = () => fetch('/v2/amenities').then(resp => resp.data)
